import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const API_URL = environment.apiUrl;

export interface BlogPost {
  id?: number;
  title: string;
  slug?: string;
  excerpt?: string;
  content: string;
  imageUrl?: string;
  author?: string;
  tags?: string[];
  isPublished?: boolean;
  publishedAt?: string;
  createdAt?: string;
}

@Injectable({ providedIn: 'root' })
export class BlogService {
  constructor(private http: HttpClient) {}

  getPosts(): Observable<BlogPost[]> {
    return this.http.get<BlogPost[]>(`${API_URL}/api/bakery/blog`).pipe(
      map(posts => posts.map(p => this.normalize(p)))
    );
  }

  getPostById(id: string): Observable<BlogPost | undefined> {
    return this.http.get<BlogPost>(`${API_URL}/api/bakery/blog/${id}`).pipe(
      map(p => this.normalize(p))
    );
  }

  getPostBySlug(slug: string): Observable<BlogPost | undefined> {
    return this.getPosts().pipe(
      map(posts => posts.find(p => p.slug === slug))
    );
  }

  // ── Admin methods ──
  getAllPostsAdmin(headers: HttpHeaders): Observable<BlogPost[]> {
    return this.http.get<BlogPost[]>(`${API_URL}/api/bakery/blog/all`, { headers }).pipe(
      map(posts => posts.map(p => this.normalize(p)))
    );
  }

  createPost(post: Partial<BlogPost>, headers: HttpHeaders): Observable<BlogPost> {
    return this.http.post<BlogPost>(`${API_URL}/api/bakery/blog`, post, { headers });
  }

  updatePost(id: string, post: Partial<BlogPost>, headers: HttpHeaders): Observable<BlogPost> {
    return this.http.put<BlogPost>(`${API_URL}/api/bakery/blog/${id}`, post, { headers });
  }

  deletePost(id: string, headers: HttpHeaders): Observable<any> {
    return this.http.delete(`${API_URL}/api/bakery/blog/${id}`, { headers });
  }

  private normalize(p: any): BlogPost {
    const raw = { ...p, id: String(p.id) };
    if (typeof raw.tags === 'string') {
      try { raw.tags = JSON.parse(raw.tags); } catch { raw.tags = []; }
    }
    if (!Array.isArray(raw.tags)) raw.tags = [];
    return raw;
  }
}
